import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { FeatureFlag, FeatureFlagCreate, FeatureFlagFilter } from '../data/featureFlag';

export function createFeatureFlagService(client: AxiosInstance) {
  return createCrudService<FeatureFlag, FeatureFlagCreate, FeatureFlagFilter>(
    client,
    '/platform/FeatureFlag',
    'id',
  );
}

export type FeatureFlagService = CrudService<FeatureFlag, FeatureFlagCreate, FeatureFlagFilter>;
